import React, { useState } from 'react';

import { cn } from 'revibe-ui';
import { useFormikContext } from 'formik';
import { useTranslation } from 'i18n/hooks';
import { FormControl } from 'revibe-ui';

import { useMediaQuery } from 'modules/common/hooks';
import { ITEM_FILTERS } from 'modules/item/utils/itemFilter';
import { MarketplaceAPI } from 'revibe-api';

export const SizeFilter = () => {
  const { tu } = useTranslation('listing.filters');
  const { isMobile } = useMediaQuery();
  const { values, setFieldValue, handleSubmit } =
    useFormikContext<MarketplaceAPI.ItemFilters>();
  const [selectedSizes, setSelectedSizes] = useState(
    (values[ITEM_FILTERS.SIZE] as string)
      .split(',')
      .filter((size) => size !== '')
  );

  return (
    <div className="w-full">
      <FormControl label={tu('sizes')}>
        <div className="grid grid-cols-4 gap-2">
          {['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', '3xl'].map((size) => (
            <p
              key={size}
              className={cn(
                'cursor-pointer border bg-gray-50 p-2 text-center text-xs font-light uppercase hover:text-black',
                selectedSizes.includes(size)
                  ? 'border-black text-black hover:border-black'
                  : 'border-gray-200 text-gray-400 hover:border-black'
              )}
              onClick={() => {
                const sizeIndex = selectedSizes.findIndex((s) => s === size);
                let newSelectedSizes: string[] = [];
                if (sizeIndex !== -1) {
                  newSelectedSizes = [
                    ...selectedSizes.slice(0, sizeIndex),
                    ...selectedSizes.slice(sizeIndex + 1),
                  ];
                } else {
                  newSelectedSizes = [...selectedSizes, size];
                }
                setSelectedSizes(newSelectedSizes);
                setFieldValue(ITEM_FILTERS.SIZE, newSelectedSizes.join(','));
                !isMobile && handleSubmit();
              }}
            >
              {size.toUpperCase()}
            </p>
          ))}
        </div>
      </FormControl>
    </div>
  );
};
